import { useQuery } from "@tanstack/react-query";
import useWidgetStore from "../../../store/useWidgetStore";
import ConfigHolder from "../../../config/ConfigHolder";
import { useSettings } from "../../../context/SettingsContext";
export const useGroups = (options) => {
    const { api_key, widget_id } = useSettings();
    const { enabled } = useWidgetStore();
    const defaultOptions = Object.assign(Object.assign({}, options), { enabled: enabled.group, networkMode: "online", cacheTime: 60 * 1000 * 10, staleTime: 60 * 1000 * 10 });
    return useQuery(Object.assign(Object.assign({}, defaultOptions), { queryKey: ['widget-group'], queryFn: async ({ signal }) => {
            let url = ConfigHolder.getApiMethodUrl(api_key, widget_id, 'appTypeGroups', 'core');
            const response = await fetch(url.href, {
                signal: signal,
                headers: {
                    'accept': 'application/ld+json',
                }
            });
            return response.json();
        } }));
};
